import axios from "axios";
import { signOut } from "firebase/auth";
import StorageUtils from "../utils/StorageUtils";
import { firebaseAuth } from "./FirebaseConfig";
import { obterTokenAtualizado, sessaoExpirada } from "../utils/sessao";

const api = axios.create({
  // baseURL: "https://api-agriholmes-prov.azurewebsites.net/api/",
  // baseURL: "https://sistema.pontualsys.com.br/api-agriholmes/api/",
  baseURL: process.env.REACT_APP_API_URL ?? "https://desenvolvimento.painel-agholmes-1.com.br/api/",
  timeout: 120000
});

export async function encerrarSessao(): Promise<void> {
  await StorageUtils.clearStorage();
  try {
    await signOut(firebaseAuth);
  } catch {
    // sem sessão do Firebase para encerrar
  }
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
}

api.interceptors.request.use(
  async (config: any) => {
    const tokenGuardado = await StorageUtils.getToken();

    if (!tokenGuardado) {
      return config
    }

    // DEVN3-760: sessões anteriores ao deploy não têm a hora do login; contam a partir daqui.
    const inicio = StorageUtils.getSessaoInicio();
    if (inicio === null) {
      StorageUtils.setSessaoInicio(Date.now());
    } else if (sessaoExpirada(inicio)) {
      await encerrarSessao();
      throw new axios.Cancel('Sessão expirada');
    }

    await firebaseAuth.authStateReady();
    const accessToken = await obterTokenAtualizado(firebaseAuth.currentUser, tokenGuardado);

    if (accessToken !== tokenGuardado) {
      StorageUtils.setToken(accessToken);
    }

    config.headers.Authorization = `Bearer ${accessToken}`

    return config
  },
  (err: any) => Promise.reject(err)
)

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error: any) => {
    if (error?.response?.status === 401) {
      await encerrarSessao();
      return Promise.reject(error);
    }

    if (error?.response?.data) {
      let data = error.response.data;

      if (data instanceof Blob) {
        try {
          const text = await data.text();
          const parsed = JSON.parse(text);
          data = parsed.message || parsed.error || text;
        } catch {
          data = 'Erro desconhecido';
        }
      } else if (typeof data === 'object' && data !== null) {
        data = data.message || data.error || JSON.stringify(data);
      }

      return Promise.reject({ message: data });
    }

    return Promise.reject(error);
  }
)

export default api;